import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import zh from './locales/zh.json';
import { getLanguage } from './services/profileService';

console.log('Before i18n initialization:', {
  enLoaded: !!en,
  zhLoaded: !!zh,
  enKeys: Object.keys(en),
  zhKeys: Object.keys(zh)
});

// Initialize i18n with both languages
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh }
    },
    lng: 'zh', // default language
    fallbackLng: 'zh',
    supportedLngs: ['en', 'zh'],
    debug: true,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    },
    load: 'languageOnly',
    preload: ['en', 'zh'],
    ns: ['translation'],
    defaultNS: 'translation'
  });

console.log('After i18n initialization:', {
  languages: i18n.languages,
  currentLanguage: i18n.language,
  resources: Object.keys(i18n.options.resources || {}),
  hasLoadedNamespace: i18n.hasLoadedNamespace
});

// Force both languages to be available
i18n.languages = ['en', 'zh'];

// Function to update language from backend
export const updateLanguageFromBackend = async (): Promise<void> => {
  try {
    const langCode = await getLanguage();
    console.log('Backend language response:', {
      langCode,
      availableLanguages: i18n.languages,
      currentLanguage: i18n.language
    });
    if (langCode && i18n.languages.includes(langCode)) {
      await i18n.changeLanguage(langCode);
    }
  } catch (error) {
    console.error('Error fetching preferred language:', error);
  }
};

let user: unknown = null;
const userString = localStorage.getItem('user');
if (userString) {
  try {
    user = JSON.parse(userString);
  } catch (error) {
    console.error("Failed to parse user data from localStorage:", error);
  }
}

if (user) {
  updateLanguageFromBackend();
}

export default i18n;
